import Router from 'next/router';
import NProgress from 'nprogress';
import { FC, useEffect } from 'react';

const PageProgress: FC = () => {
  useEffect(() => {
    const routeChangeStart = (): void => {
      NProgress.start();
    };
    const routeChangeEnd = (): void => {
      NProgress.done();
    };

    NProgress.configure({});

    Router.events.on('routeChangeStart', routeChangeStart);
    Router.events.on('routeChangeComplete', routeChangeEnd);
    Router.events.on('routeChangeError', routeChangeEnd);

    return () => {
      Router.events.off('routeChangeStart', routeChangeStart);
      Router.events.off('routeChangeComplete', routeChangeEnd);
      Router.events.off('routeChangeError', routeChangeEnd);
    };
  }, []);

  return null;
};

export default PageProgress;
